import { serviceMaker, methods, api } from "./../index.js";

export const getUomList = () =>
    serviceMaker(`/unitofmeasurement?limit=14&offset=0`, methods.GET, api.NGB);
export const dataByIdUom = (id) =>
    serviceMaker(`/unitofmeasurement/${id}`, methods.GET, api.NGB);
export const editUomData = (id) =>
    serviceMaker(`/unitofmeasurement/${id}?template=true`, methods.GET, api.NGB);
export const updateUomElement = (id, data) =>
    serviceMaker(`/unitofmeasurement/${id}`, methods.PUT, api.NGB, data);
export const createUomElement = (data) =>
    serviceMaker(`/unitofmeasurement`, methods.POST, api.NGB, data);
export const deleteUnitofMeasurement = (id) =>
    serviceMaker(`/unitofmeasurement/delete/${id}`, methods.DELETE, api.NGB);
export const deleteRUM = (id) =>
    serviceMaker(`/ratableusagemetric/delete/${id}`, methods.DELETE, api.NGB);
export const createRateBalance = (data) =>
    serviceMaker(`/usageratebalance`, methods.POST, api.NGB, data);
export const getRumList = () =>
    serviceMaker(`/ratableusagemetric?limit=14&offset=0`, methods.GET, api.NGB);
export const dataByIdRum = (id) =>
    serviceMaker(`/ratableusagemetric/${id}`, methods.GET, api.NGB);
export const getRUMElementTemplate = () =>
    serviceMaker(`/ratableusagemetric/template`, methods.GET, api.NGB);
export const editRUMElementData = (id) =>
    serviceMaker(`/ratableusagemetric/${id}?template=true`, methods.GET, api.NGB);
export const updateRumElement = (id, data) =>
    serviceMaker(`/ratableusagemetric/${id}`, methods.PUT, api.NGB, data);
export const createRumElement = (data) =>
    serviceMaker(`/ratableusagemetric`, methods.POST, api.NGB, data);
export const getRUMDropdownTemplate = () =>
    serviceMaker(`/ratableusagemetric/dropdown`, methods.GET, api.NGB);
export const getRUMChargeCodeTemplate = () =>
    serviceMaker(`/chargecode`, methods.GET, api.NGB);
export const getByIdRum = (id) =>
    serviceMaker(`/template/view/${id}`, methods.GET, api.NGB);
// export const getTimeModel = () => serviceMaker(`/timemodel`, methods.GET, api.NGB);
export const getTimeModel = () =>
    serviceMaker(`/rateplan/getTimeModel`, methods.GET, api.NGB);
export const getQuantityTire = (id) =>
    serviceMaker(`/usageratequantitytier/rateplan/${id}`, methods.GET, api.NGB);

//usagecreate
export const getUsageTemplate = () =>
    serviceMaker(`/rateplan/template`, methods.GET, api.NGB);
export const getUsageRateTemplate = () =>
    serviceMaker(`/usageratebalance/template`, methods.GET, api.NGB);
// export const rateplan = (payload) =>
// serviceMaker(`/rateplan/${payload.id}`, methods.PUT, api.NGB, payload.data);
export const updateUsageRate = (id, data) =>
    serviceMaker(
        `/usageratebalance/${id}`,
        methods.PUT,
        api.NGB,
        data
    );

//export const getTimeModel = () => serviceMaker(`/timemodel`, methods.GET, api.NGB);
// export const getTimeModel = () => serviceMaker(`/rateplan/getTimeModel`, methods.GET, api.NGB);
export const saveTimeModel = (data) =>
    serviceMaker(`/timemodel`, methods.POST, api.NGB, data);
//create apis
export const saveYear = (data) =>
    serviceMaker(`/usagetimeperiodyear`, methods.POST, api.NGB, data);
export const savemonths = (data) =>
    serviceMaker(`/usagetimeperiodmonth`, methods.POST, api.NGB, data);
export const saveDays = (data) =>
    serviceMaker(`/usagetimeperiodday`, methods.POST, api.NGB, data);
export const saveTimes = (data) =>
    serviceMaker(`/usagetimeperiodtime`, methods.POST, api.NGB, data);
//update apis
export const updateYear = (id, data) =>
    serviceMaker(`/usagetimeperiodyear/${id}`, methods.PUT, api.NGB, data);
export const updatemonths = (id, data) =>
    serviceMaker(`/usagetimeperiodmonth/${id}`, methods.PUT, api.NGB, data);
export const updateDays = (id, data) =>
    serviceMaker(`/usagetimeperiodday/${id}`, methods.PUT, api.NGB, data);
export const updateTimes = (id, data) =>
    serviceMaker(`/usagetimeperiodtime/${id}`, methods.PUT, api.NGB, data);
export const saveMonth = (id, data) =>
    serviceMaker(`/timeperiod/${id}`, methods.PUT, api.NGB, data);
//timemodel
export const getTimePeriodList = () =>
    serviceMaker(`/timeperiod`, methods.GET, api.NGB);
export const getTemplateList = () =>
    serviceMaker(`/template`, methods.GET, api.NGB);
export const getViewTemplate = (id) =>
    serviceMaker(`/template/${id}`, methods.GET, api.NGB);
export const createTemplate = (data) =>
    serviceMaker(`/template`, methods.POST, api.NGB, data);
export const getTemplateById = (id) =>
    serviceMaker(`/template/${id}?template=true`, methods.GET, api.NGB);
export const editTemplate = (id, data) =>
    serviceMaker(`/template/${id}`, methods.PUT, api.NGB, data);

export const getUsageRatePlanList = () =>
    serviceMaker(`/rateplan`, methods.GET, api.NGB);
export const saveRatePlan = (data) =>
    serviceMaker(`/rateplan`, methods.POST, api.NGB, data);
export const getTimemodelList = (id) =>
    serviceMaker(`/rateplan/timemodel/${id}`, methods.GET, api.NGB);
export const editTimeModel = (id, data) =>
    serviceMaker(`/timemodel/${id}`, methods.PUT, api.NGB, data);
export const editYear = (id, data) =>
    serviceMaker(`/timeperiod/${id}`, methods.PUT, api.NGB, data);
export const deletetimemodel = (id) =>
    serviceMaker(`/timemodel/${id}`, methods.DELETE, api.NGB);
export const deletetimemodelyear = (id) =>
    serviceMaker(`/usagetimeperiodyear/${id}`, methods.DELETE, api.NGB);
export const deletetimemodelmonth = (id) =>
    serviceMaker(`/usagetimeperiodmonth/${id}`, methods.DELETE, api.NGB);
export const deletetimemodelday = (id) =>
    serviceMaker(`/usagetimeperiodday/${id}`, methods.DELETE, api.NGB);
export const deletetimemodeltime = (id) =>
    serviceMaker(`/usagetimeperiodtime/${id}`, methods.DELETE, api.NGB);
export const delateUsageRate = (id) =>
    serviceMaker(`/usageratebalance/${id}`, methods.DELETE, api.NGB);
export const deletetimeperiod = (id) =>
    serviceMaker(`/timeperiod/${id}`, methods.DELETE, api.NGB);
export const saveQuantityTier = (data) =>
    serviceMaker(`/usageratequantitytier`, methods.POST, api.NGB, data);
export const deleteTemplateDefinition = (id) =>
    serviceMaker(`/template/delete/${id}`, methods.DELETE, api.NGB);
//view usagerating
export const viewUsage = (id) =>
    serviceMaker(`/rateplan/${id}`, methods.GET, api.NGB);
export const viewUsageRateBalance = (id) =>
    serviceMaker(`/usageratebalance/${id}`, methods.GET, api.NGB);
export const updateQuantitytierElement = (tierId, data) =>
    serviceMaker(`/usageratequantitytier/${tierId}`, methods.PUT, api.NGB, data);
